import Switcher from "./Switcher.js";
import { setTheme, getTheme } from "../store/index.js";
class ThemeSwitcher extends Switcher {
  static config = {
    name: "ThemeSwitcher"
  };
  async mounted() {
    const value = await getTheme();
    const input = this.$refs.inputs.find((i) => i.value === value);
    if (input) {
      this.$write(() => {
        input.checked = true;
      });
    }
  }
  switch(value) {
    setTheme(value);
  }
  async onWindowHashchange({ event }) {
    const url = new URL(event.newURL);
    const params = new URLSearchParams(url.hash.replace("#", ""));
    const theme = params.get("theme");
    if (theme !== await getTheme()) {
      setTheme(theme);
    }
  }
}
export {
  ThemeSwitcher as default
};
//# sourceMappingURL=ThemeSwitcher.js.map
